import { ActionMenu, ConfirmationDialog } from '@ijoin/components';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';

import { camelCase } from 'lodash';
import { useToggle } from 'usehooks-ts';

export const RkoLicenseActionsCell = (props: {
  description: string;
  onRemove: () => void;
}) => {
  const [isRemoveOpen, toggleRemoveOpen] = useToggle();

  const onConfirmRemove = () => {
    toggleRemoveOpen();
    props.onRemove();
  };

  return (
    <>
      <ActionMenu
        actions={[{ content: 'Remove', onSelect: toggleRemoveOpen }]}
        trigger={
          <IconButton data-testid={`actions-${camelCase(props.description)}`}>
            <MoreVertIcon />
          </IconButton>
        }
      />
      <ConfirmationDialog
        confirmColor='error'
        confirmText='Remove'
        data-testid={camelCase(`remove ${props.description}`)}
        isOpen={isRemoveOpen}
        message={`Remove the ${props.description} license from this record keeping organization?`}
        onCancel={toggleRemoveOpen}
        onConfirm={onConfirmRemove}
        title='Remove License'
      />
    </>
  );
};
